import { render, staticRenderFns } from "./AiDisplaySkills.vue?vue&type=template&id=48cc6144&scoped=true"
import script from "./AiDisplaySkills.vue?vue&type=script&lang=js"
export * from "./AiDisplaySkills.vue?vue&type=script&lang=js"
import style0 from "./AiDisplaySkills.vue?vue&type=style&index=0&id=48cc6144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc6144",
  null
  
)

export default component.exports